import up from 'unpoly';
import { fillUtmParams } from '../front/tracking';

up.compiler('.js-form-fill-utm-tags', fillUtmParams);
